/**
 * Where embedded widgets are hosted.
 * Dev: same Vite server (localhost). Production: widgets subdomain.
 */
export function getRuntimeOrigin() {
  if (import.meta.env.PROD) {
    return 'https://widgets.scorewidget.com';
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'http://localhost:5173';
}
